// src/components/common/OriginCityInput.jsx
// "Travelling from" box on trip pages: type a city, airport or railway station and pick from the
// search form's airport and station lists (popular ones first). No Google places here.
// onPick gets a place { name, lat, lng, code?, kind? }. The lists load on first focus, so trip pages
// stay light until someone changes the city.
import React, { Suspense, lazy, useEffect, useRef, useState } from "react";

const OriginAutocomplete = lazy(() => import("./OriginAutocomplete"));

export default function OriginCityInput({ value = "", onPick, placeholder = "Airport or railway station", style, className, ariaLabel = "Travelling from", minWidth = 300 }) {
    const [text, setText] = useState(value);
    const [armed, setArmed] = useState(false);     // lists loaded
    const [err, setErr] = useState("");
    const boxRef = useRef(null);
    const pickedRef = useRef(false);
    useEffect(() => { setText(value); }, [value]);

    const onPlace = (place) => {
        pickedRef.current = true;
        if (!place) { setErr("We can't plan from that one yet. Pick a nearby station or airport."); setText(value); return; }
        setErr("");
        setText(place.name);
        onPick?.(place);
    };
    // Leaving the box without a pick puts the current city back
    const onBlur = () => setTimeout(() => { if (!pickedRef.current) setText(value); pickedRef.current = false; }, 260);
    const onFocus = (e) => { if (!armed) setArmed(true); try { e.target.select(); } catch { /* not selectable */ } };

    const plain = (
        <input type="text" value={text} placeholder={placeholder} aria-label={ariaLabel} style={style} className={className}
            onFocus={onFocus} onChange={(e) => { setArmed(true); setText(e.target.value); }} />
    );
    return (
        <div ref={boxRef} style={{ position: "relative", width: "100%", minWidth: 0 }} onBlur={onBlur} onFocus={onFocus}>
            {armed ? (
                <Suspense fallback={plain}>
                    <OriginAutocomplete value={text} onChange={setText} onPlace={onPlace} placeholder={placeholder}
                        style={style} className={className} ariaLabel={ariaLabel} anchorRef={boxRef} minWidth={minWidth} autoFocus />
                </Suspense>
            ) : plain}
            {err && <div role="alert" style={{ fontSize: 11.5, color: "#B91C1C", marginTop: 4 }}>{err}</div>}
        </div>
    );
}
